// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3Ji_d","left":"InfoRow_left__1dE17"};